export const StorageKeys = {
  USER: 'user',
  TOKEN: 'access_token'
}

